<script setup lang="ts">
import { useErrorFormatter } from '#layers/ui/public';

defineProps<{
	error: unknown;
}>();

const { formatError } = useErrorFormatter();
</script>

<template>
	<div class="inline-flex items-center gap-1 rounded-sm bg-warning/10 py-0.5 ps-1 pe-2">
		<DIcon name="lucide:triangle-alert" class="size-5 text-warning" />
		<span class="text-xs font-medium">{{ formatError(error) }}</span>
	</div>
</template>
